











































































































































































import { Component, Watch, Vue } from 'vue-property-decorator';
import FanMech from '../components/FanMech.vue';
import FanMech2 from '../components/FanMech2.vue';

@Component({
  components: {
    FanMech,
    FanMech2,
  },
})
export default class About extends Vue {
 private screenSize: number = screen.width;
 @Watch('screenSize')
    private onchange(val: number, oldVal: number) {
      this.screenSize = val;
    }

  private mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.screenSize = window.innerWidth;
      });
    });
  }
  /* TODO: Move data to service */
 private data() {
   return {
     assets: {
       mobile: {
         neckA: {
           url: require('../assets/about-mech/mobile/mobile-neck-1_220x20.png'),
           alt: 'Mobile Neck 1',
         },
         elbowA: {
           url: require('../assets/about-mech/mobile/mobile-elbow-1_80x70.png'),
           alt: 'Mobile Elbow 1',
         },
        neckB: {
           url: require('../assets/about-mech/mobile/mobile-neck-2_28x358.png'),
           alt: 'Mobile Neck 2',
         },
         elbowB: {
            url: require('../assets/about-mech/mobile/mobile-elbow-3_52x70.png'),
           alt: 'Mobile Elbow 2',
         },
         neckC: {
           url: require('../assets/about-mech/mobile/mobile-neck-3_212x18.png'),
           alt: 'Mobile Neck 3',
         },
        elbowC: {
           url: require('../assets/about-mech/mobile/mobile-elbow-4_68x54.png'),
           alt: 'Mobile Elbow 3',
         },
         neckD: {
           url: require('../assets/about-mech/mobile/mobile-neck-4_18x740.png'),
           alt: 'Mobile Neck 4',
         },
         elbowE: {
           url: require('../assets/about-mech/mobile/mobile-elbow_54x70.png'),
           alt: 'Mobile Elbow 4',
         },
         neckE: {
           url: require('../assets/about-mech/mobile/mobile-neck-5_212x18.png'),
           alt: 'Mobile Neck 5',
         },
         elbowF: {
           url: require('../assets/about-mech/mobile/mobile-elbow_72x54.png'),
           alt: 'Mobile Elbow 5',
         },
         neckF: {
           url: require('../assets/about-mech/mobile/mobile-neck_28x495.png'),
           alt: 'Mobile Neck 6',
         },
         neckG: {
           url: require('../assets/about-mech/mobile/mobile-neck_28x368.png'),
           alt: 'Mobile Neck 7',
         },
         elbowG: {
           url: require('../assets/about-mech/mobile/mobile-elbow-3_52x70.png'),
           alt: 'Mobile Elbow 6',
         },
         neckH: {
           url: require('../assets/about-mech/mobile/mobile-neck-3_212x18.png'),
           alt: 'Mobile Neck 8',
         },
         elbowH: {
           url: require('../assets/about-mech/mobile/mobile-elbow-4_68x54.png'),
           alt: 'Mobile Elbow 7',
         },
         neckI: {
           url: require('../assets/about-mech/mobile/mobile-neck_28x838.png'),
           alt: 'Mobile Neck 9',
         },
         neckJ: {
           url: require('../assets/about-mech/mobile/mobile-neck_48x834.png'),
           alt: 'Mobile Neck 10',
         },
       },
       tablet: {
         neckA: {
           url: require('../assets/about-mech/tablet/tablet-neck-1_523x18.png'),
           alt: 'Tablet Neck 1',
         },
         elbowA: {
           url: require('../assets/about-mech/tablet/tablet-elbow-1_75x98.png'),
           alt: 'Tablet Elbow 1',
         },
         neckB: {
           url: require('../assets/about-mech/tablet/tablet-neck-2_28x214.png'),
           alt: 'Tablet Neck 2',
         },
         elbowB: {
           url: require('../assets/about-mech/tablet/tablet-elbow-2_56x74.png'),
           alt: 'Tablet Elbow 2',
         },
         neckC: {
           url: require('../assets/about-mech/tablet/tablet-neck-3_544x18.png'),
           alt: 'Tablet Neck 3',
         },
         elbowC: {
           url: require('../assets/about-mech/tablet/tablet-elbow-3_72x56.png'),
           alt: 'Tablet Elbow 3',
         },
         neckD: {
           url: require('../assets/about-mech/tablet/tablet-neck-4_18x450.png'),
           alt: 'Tablet Neck 4',
         },
         elbowD: {
           url: require('../assets/about-mech/tablet/tablet-elbow-4_56x72.png'),
           alt: 'Tablet Elbow 4',
         },
         neckE: {
           url: require('../assets/about-mech/tablet/tablet-neck-5_532x18.png'),
           alt: 'Tablet Neck 5',
         },
         elbowE: {
           url: require('../assets/about-mech/tablet/tablet-elbow-5_72x86.png'),
           alt: 'Tablet Elbow 5',
         },
         neckF: {
           url: require('../assets/about-mech/tablet/tablet-neck-6_28x496.png'),
           alt: 'Tablet Neck 6',
         },
         neckG: {
           url: require('../assets/about-mech/tablet/tablet-neck-7_28x236.png'),
           alt: 'Tablet Neck 7',
         },
         elbowF: {
           url: require('../assets/about-mech/tablet/tablet-elbow-6_56x74.png'),
           alt: 'Tablet Elbow 6',
         },
          neckH: {
            url: require('../assets/about-mech/tablet/tablet-neck-8_532x18.png'),
            alt: 'Tablet Neck 8',
          },
         elbowG: {
           url: require('../assets/about-mech/tablet/tablet-elbow-7_72x56.png'),
           alt: 'Tablet Elbow 7',
         },
         neckI: {
           url: require('../assets/about-mech/tablet/tablet-neck-9_28x588.png'),
           alt: 'Tablet Neck 9',
          },
          neckJ: {
           url: require('../assets/about-mech/tablet/tablet-neck-10_48x690.png'),
           alt: 'Tablet Neck 10',
        },
       },
       desktop: {
         neckA: {
           url: require('../assets/about-mech/desktop/desktop-neck-1_532x18.png'),
           alt: 'Desktop Neck 1',
         },
         elbowA: {
           url: require('../assets/about-mech/desktop/desktop-elbow-1_76x98.png'),
           alt: 'Desktop Elbow 1',
         },
          elbowB: {
           url: require('../assets/about-mech/desktop/desktop-elbow-2_60x86.png'),
           alt: 'Desktop Elbow 2',
         },
         neckB: {
           url: require('../assets/about-mech/desktop/desktop-neck-2_212x18.png'),
           alt: 'Desktop Neck 2',
         },
         elbowC: {
           url: require('../assets/about-mech/desktop/desktop-elbow-3_72x56.png'),
           alt: 'Desktop Elbow 3',
         },
         neckC: {
           url: require('../assets/about-mech/desktop/desktop-neck-3_18x432.png'),
           alt: 'Desktop Neck 3',
         },
         elbowD: {
           url: require('../assets/about-mech/desktop/desktop-elbow-4_56x72.png'),
           alt: 'Desktop Elbow 4',
         },
         neckD: {
           url: require('../assets/about-mech/desktop/desktop-neck-4_342x18.png'),
           alt: 'Desktop Neck 4',
         },
         elbowE: {
           url: require('../assets/about-mech/desktop/desktop-elbow-5_72x86.png'),
           alt: 'Desktop Elbow 5',
         },
         neckE: {
           url: require('../assets/about-mech/desktop/desktop-neck-5_18x392.png'),
           alt: 'Desktop Neck 5',
         },
         valveA: {
           url: require('../assets/about-mech/desktop/valve_84x84.png'),
           alt: 'Valve 1',
         },
         neckF: {
           url: require('../assets/about-mech/desktop/desktop-neck-6_18x152.png'),
           alt: 'Desktop Neck 6',
         },
         elbowF: {
           url: require('../assets/about-mech/desktop/desktop-elbow-6_56x74.png'),
           alt: 'Desktop Elbow 6',
         },
         neckG: {
           url: require('../assets/about-mech/desktop/desktop-neck-7_262x18.png'),
           alt: 'Desktop Neck 7',
         },
         elbowG: {
           url: require('../assets/about-mech/desktop/desktop-elbow-7_72x56.png'),
           alt: 'Desktop Elbow 7',
         },
         neckH: {
           url: require('../assets/about-mech/desktop/desktop-neck-8_18x592.png'),
           alt: 'Desktop Neck 8',
         },
         elbowH: {
           url: require('../assets/about-mech/desktop/desktop-elbow-8_56x72.png'),
           alt: 'Desktop Elbow 8',
         },
         neckI: {
           url: require('../assets/about-mech/desktop/desktop-neck-9_442x18.png'),
           alt: 'Desktop Neck 9',
         },
         elbowI: {
           url: require('../assets/about-mech/desktop/desktop-elbow-9_72x86.png'),
           alt: 'Desktop Elbow 9',
         },
         neckJ: {
           url: require('../assets/about-mech/desktop/desktop-neck-10_28x164.png'),
           alt: 'Desktop Neck 10',
         },
         neckK: {
           url: require('../assets/about-mech/desktop/desktop-neck-11_28x74.png'),
           alt: 'Desktop Neck 11',
         },
         elbowJ: {
           url: require('../assets/about-mech/desktop/desktop-elbow-10_56x74.png'),
           alt: 'Desktop Elbow 10',
         },
         neckL: {
           url: require('../assets/about-mech/desktop/desktop-neck-12_452x18.png'),
           alt: 'Desktop Neck 12',
         },
         elbowK: {
           url: require('../assets/about-mech/desktop/desktop-elbow-11_72x56.png'),
           alt: 'Desktop Elbow 11',
         },
         neckM: {
           url: require('../assets/about-mech/desktop/desktop-neck-13_18x832.png'),
           alt: 'Desktop Neck 13',
         },
         valveB: {
           url: require('../assets/about-mech/desktop/valve_84x84.png'),
           alt: 'Valve 2',
         },
         elbowL: {
           url: require('../assets/about-mech/desktop/desktop-elbow-12_56x72.png'),
           alt: 'Desktop Elbow 12',
         },
        neckN: {
           url: require('../assets/about-mech/desktop/desktop-neck-14_452x18.png'),
           alt: 'Desktop Neck 14',
         },
        elbowM: {
           url: require('../assets/about-mech/desktop/desktop-elbow-13_72x86.png'),
           alt: 'Desktop Elbow 13',
         },
         neckO: {
           url: require('../assets/about-mech/desktop/desktop-neck-15_28x212.png'),
           alt: 'Desktop Neck 15',
         },
         neckP: {
           url: require('../assets/about-mech/desktop/desktop-neck-16_28x134.png'),
           alt: 'Desktop Neck 16',
         },
         elbowN: {
           url: require('../assets/about-mech/desktop/desktop-elbow-14_56x74.png'),
           alt: 'Desktop Elbow 14',
         },
         neckQ: {
           url: require('../assets/about-mech/desktop/desktop-neck-17_452x18.png'),
           alt: 'Desktop Neck 17',
         },
         elbowO: {
           url: require('../assets/about-mech/desktop/desktop-elbow-15_72x56.png'),
           alt: 'Desktop Elbow 15',
         },
         neckR: {
           url: require('../assets/about-mech/desktop/desktop-neck-18_50x698.png'),
           alt: 'Desktop Neck 18',
         },
       },
       meterGlow: {
        glow: require('../assets/home-mech/gauge-D-glow_50x44.png'),
        glowAlt: 'Meter Glow',
        },
       frameA: {
        mobileUrl: require('../assets/media-assets/pass-it-down-mobile_398x294.jpg'),
        mobileWidth: '400w',
        mobileSize: '(max-width: 599px) 400px',
        tabletUrl: require('../assets/media-assets/pass-it-down-tablet_724x500.jpg'),
        tabletWidth: '708w',
        tabletSize: '(max-width: 768px) 708px',
        desktopUrl: require('../assets/media-assets/pass-it-down-desktop_676x500.jpg'),
        desktopWidth: '1116w',
        desktopSize: '(min-width: 769px) 1116px',
        alt: 'Mobile Frame A',
       },
       frameB: {
        mobileUrl: require('../assets/media-assets/primo-fruits_382x550.jpg'),
        mobileWidth: '350w',
        mobileSize: '(max-width: 599px) 350px',
        tabletUrl: require('../assets/media-assets/primo-fruits_680x964.jpg'),
        tabletWidth: '714w',
        tabletSize: '(max-width: 768px) 714px',
        desktopUrl: require('../assets/media-assets/primo-fruits-desktop_640x964.jpg'),
        desktopWidth: '1116w',
        desktopSize: '(min-width: 769px) 1116px',
        alt: 'Mobile Frame B',
       },
       frameC: {
        mobileUrl: require('../assets/media-assets/to-your-head-mobile_380x402.jpg'),
        mobileWidth: '350w',
        mobileSize: '(max-width: 599px) 350px',
        tabletUrl: require('../assets/media-assets/to-your-head_682x734.jpg'),
        tabletWidth: '714w',
        tabletSize: '(max-width: 768px) 714px',
        desktopUrl: require('../assets/media-assets/to-your-head-desktop_644x734.jpg'),
        desktopWidth: '1116w',
        desktopSize: '(min-width: 769px) 1116px',
        alt: 'Mobile Frame C',
       },
       processListItems: [
         { item:
          {
            title: 'Shape',
            term: 'no popcorn and no grapefruits, pop-corn buds are a symptom of less than optimal growing conditions and grapefruits are perhaps a little to optimal growing conditions. Well sized 2 - 4 gram nicely rounded buds are just right. selects each and every bud for quality control. While this might sound tedious and quite challenging, I assure you it is a labor of love that I am willing to endeavor.'},
          },
         { item:
          {
            title: 'Frostiness',
            term: 'our salivas are so frosty, like the evergreens on a crisp autumn morning deep in the Sierras. The more frost, the higher the terpenes, the milky tone affirms that the buds are harvested at the proper stage of flowering to fully enhance the energetic and focused characteristics of a proper Sativa high.'},
          },
         { item:
          {
            title: 'Purpling or Amberness',
            term: 'we like our indicas furry with purple and/or amber trichomes. Yummy little peaches handpicked and gently packed in baskets. The darker warmer tones of the trichomes are indicative of the exact maturing to produce the deep, relaxing body highs distinctive of the sultry and luscious indica flavors.'},
          },
         { item:
          {
            title: 'Scent',
            term: 'fragrant and sticky are the benchmark of properly cultivated cannabis with the enticing aroma attributed to high concentrates of terpenes; a testament to proper upbringing on the highest quality nutrients and in the most optimal conditions. '},
         },
       ],
     },
   };
 }
}
